import React, { useRef, useState } from "react";
import { fileUrl } from "../lib/api";
import { Play, Pause, Volume2, VolumeX, Film } from "lucide-react";

export default function VerticalVideo({ path, poster, badge = "9:16", version, testid = "vertical-video-player" }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(false);

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) { v.play(); setPlaying(true); } else { v.pause(); setPlaying(false); }
  };
  const toggleMute = () => {
    const v = ref.current;
    if (!v) return;
    v.muted = !v.muted; setMuted(v.muted);
  };

  return (
    <div className="vframe w-full max-w-[300px] mx-auto glow-strawberry" data-testid={testid}>
      {path ? (
        <video
          ref={ref} src={`${fileUrl(path)}${version ? `&v=${encodeURIComponent(version)}` : ""}`} className="h-full w-full object-cover"
          playsInline loop onClick={toggle}
          onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)}
        />
      ) : (
        <div className="h-full w-full grid place-items-center bg-gradient-to-b from-[#1a1830] to-[#0a0912]">
          <div className="text-center px-6">
            <Film className="h-10 w-10 text-slate-600 mx-auto mb-3" />
            <p className="text-sm text-slate-500">Your 9:16 preview appears here</p>
          </div>
        </div>
      )}

      <div className="absolute top-3 left-3 text-[10px] font-mono-studio px-2 py-1 rounded-md bg-black/60 backdrop-blur text-slate-200">{badge}</div>

      {path && (
        <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
          <button onClick={toggle} className="h-10 w-10 grid place-items-center rounded-full candy-strawberry text-white hover:opacity-90" data-testid="play-pause-btn">
            {playing ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4 ml-0.5" />}
          </button>
          <button onClick={toggleMute} className="h-9 w-9 grid place-items-center rounded-full bg-black/60 backdrop-blur text-white" data-testid="mute-music-btn">
            {muted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
          </button>
        </div>
      )}
    </div>
  );
}
